import { Navigate } from "react-router-dom";
import useSupportSessionGuard from "../hooks/useSupportSessionGuard";

const hasAdminAccess = (supportUser) => {
  const role = String(supportUser?.role || "").toLowerCase();
  if (["admin", "lead"].includes(role)) return true;
  const permissions = Array.isArray(supportUser?.permissions)
    ? supportUser.permissions
    : [];
  return permissions.some((perm) =>
    [
      "manage_admins",
      "manage_support_users",
      "manage_roles",
      "view_analytics",
      "view_all_users",
    ].includes(perm)
  );
};

export default function SupportAdminRoute({ children }) {
  const { checking, supportUser } = useSupportSessionGuard();

  if (checking) {
    return <div className="min-h-screen bg-[#171717]" />;
  }

  if (!supportUser?.id) {
    return <Navigate to="/u/support/admin/login" replace />;
  }

  if (supportUser.isSuperAdmin || String(supportUser.role || "").toLowerCase() === "superadmin") {
    return <Navigate to="/u/admin" replace />;
  }
  if (!hasAdminAccess(supportUser)) {
    return <Navigate to="/u/support/agent" replace />;
  }

  return children;
}
